export const VIDEO_MIME_TYPES = {
  HLS: 'application/x-mpegurl',
  WEBM: 'video/webm',
  OGG: 'video/ogg',
  MP4: 'video/mp4',
  '3GP': 'video/3gp',
};

export const VIDEO_SPEEDS = [
  { label: '0.25X', value: 0.25 },
  { label: '0.5X', value: 0.5 },
  { label: '0.75X', value: 0.75 },
  { label: '1X', value: 1 },
  { label: '1.25X', value: 1.25 },
  { label: '1.5X', value: 1.5 },
  { label: '1.75X', value: 1.75 },
  { label: '2X', value: 2 },
];

export const KEY_CODES = {
  // toggle play
  spacebar: 32,
  // volume controls
  arrowUp: 38,
  arrowDown: 40,
  m: 77,
  // skip 10 seconds
  arrowRight: 39,
  arrowLeft: 37,
  // fullscreen
  f: 70,
  // add note
  a: 65,
};

export const REMAINING_SECONDS_TO_SKIP = 15;

export const REMAINING_SECONDS_TO_IDLE_SCREEN = 3;

// Useful to hide controls on iPhone devices
export const IS_IPHONE =
  typeof window !== 'undefined' &&
  window.navigator &&
  /iPhone/.test(window.navigator.userAgent) &&
  !window.MSStream;
